/* @flow */
import * as React from "react";
import { lighten } from "polished";
import {
  withColorsProvider,
  type ColorSet,
} from "nx-components/ColorsProvider";
import prefixStyles from "nx-components/utils/prefixStyles";
import Toggle from "nx-components/Toggle";
import Tappable, { simpleActiveBackgroundColor } from "nx-components/Tappable";
import { IconThinChevronRight, IconThinChevronLeft } from "nx-components/Icons";

type Props = {
  isShowNewsChecked: boolean,
  onShowNewsClicked: () => void,
  onBackArrowClicked?: ?() => void,
  onForwardArrowClicked?: ?() => void,
  colors: ColorSet,
};

class NewsControls extends React.Component<Props> {
  render() {
    const {
      isShowNewsChecked,
      onShowNewsClicked,
      onBackArrowClicked,
      onForwardArrowClicked,
      colors,
    } = this.props;

    const styles = prefixStyles({
      wrapper: {
        padding: "0.5em",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        flexShrink: "0",
      },
      showAtStartupWrapper: {
        marginRight: "auto",
        display: "flex",
        position: "relative",
        alignItems: "center",
        cursor: "pointer",
        flexBasis: "5.5em",
      },
      showAtStartupLabel: {
        fontSize: "0.8em",
      },
      checkboxWrapper: {
        marginRight: "0.25em",
        flexShrink: 0, // iOS <10 doesn't properly prevent shrinking when overflow is visible: https://stackoverflow.com/questions/36247140/why-doesnt-flex-item-shrink-past-content-size
      },
      arrow: {
        flexShrink: "0",
      },
      clickableArrow: {
        color: colors.PRIMARY,
        cursor: "pointer",
      },
      disabledArrow: {
        color: lighten(0.4, colors.TEXT),
      },
      backArrowWrapper: {
        marginLeft: "0.5em",
        padding: "0 0.5em",
      },
      forwardArrowWrapper: {
        marginLeft: "1em",
        padding: "0 0.5em",
      },
    });

    return (
      <div data-component-name="NewsControls" style={styles.wrapper}>
        <div
          data-component-section="show-at-startup"
          style={styles.showAtStartupWrapper}
        >
          <div style={styles.checkboxWrapper}>
            <Toggle checked={isShowNewsChecked} onChange={onShowNewsClicked} />
          </div>
          <Tappable onTap={onShowNewsClicked}>
            {({ tapTargetRefHandler }) => (
              <div
                ref={tapTargetRefHandler}
                tabIndex="0"
                style={styles.showAtStartupLabel}
                data-component-section="label"
              >
                Show news at startup?
              </div>
            )}
          </Tappable>
        </div>
        <Tappable onTap={onBackArrowClicked}>
          {({ active, tapTargetRefHandler }) => (
            <div
              style={{
                ...styles.backArrowWrapper,
                ...(onBackArrowClicked
                  ? styles.clickableArrow
                  : styles.disabledArrow),
                backgroundColor: simpleActiveBackgroundColor(active),
              }}
              ref={tapTargetRefHandler}
              tabIndex="0"
            >
              <IconThinChevronLeft style={styles.arrow} />
            </div>
          )}
        </Tappable>
        <Tappable onTap={onForwardArrowClicked}>
          {({ active, tapTargetRefHandler }) => (
            <div
              style={{
                ...styles.forwardArrowWrapper,
                ...(onForwardArrowClicked
                  ? styles.clickableArrow
                  : styles.disabledArrow),
                backgroundColor: simpleActiveBackgroundColor(active),
              }}
              ref={tapTargetRefHandler}
              tabIndex="0"
            >
              <IconThinChevronRight style={styles.arrow} />
            </div>
          )}
        </Tappable>
      </div>
    );
  }
}

export default withColorsProvider(NewsControls);



// WEBPACK FOOTER //
// ./src/components/News/NewsControls.jsx